import Avatar, { AVATAR_LOCKED } from './Avatar';

/**
 * The whole app, for somebody it is shut to.
 *
 * Two states share it, because what a person can do about either is the same
 * thing: nothing but wait for the regent. `paused` is somebody the regent took
 * out of the choir for a while; `pending` is somebody who followed the link and
 * has not been let in yet.
 *
 * **The reason for a pause is not on this screen.** It was written by the regent
 * for himself, and the person hears it from him rather than from the app —
 * which is the same rule that keeps it off a singer's copy of the roster. A
 * sentence like «Уехала учиться» read back to somebody by a machine is the app
 * taking a side in a conversation it is not in.
 *
 * No tab bar and no header: there is nothing under this to navigate to. The
 * face is grey and has no mouth, because the smile is thirty days of attendance
 * and there are none — and the figure is the neutral one, because at this point
 * the app has not loaded a profile at all. There is no token; there is nothing
 * to load it with.
 */
export default function Waiting({ standing }: { standing: 'pending' | 'paused' }) {
  return (
    <section className="waiting">
      <Avatar
        // Neutral throughout: the sixth colour is the grey one, the shape is the
        // one that means «no part stated», and the eyes are the plain pair. This
        // is not anybody's own avatar and must not pretend to be.
        eyes={2}
        color={6}
        size={AVATAR_LOCKED}
        away
      />
      {standing === 'paused' ? (
        <>
          <h1 className="screen-title">Ты сейчас не в составе</h1>
          <p className="waiting-fact">
            Пауза от регента. Пока она стоит, спевок, программы и напоминаний не будет — бот
            тоже писать не станет.
          </p>
          <p className="hint">
            Отметки за прошлые спевки никуда не делись. Вернуть в состав может регент.
          </p>
        </>
      ) : (
        <>
          <h1 className="screen-title">Заявка отправлена</h1>
          <p className="waiting-fact">
            Регент увидит её на экране хора. Пока не примет, хор не открыт.
          </p>
        </>
      )}
    </section>
  );
}
